module.exports = __webpack_public_path__ + "static/img/ic_dr.4b49bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_dr.png
// module id = XtIi
// module chunks = 0